import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { AuthShellComponent } from '../auth-shell/auth-shell.component';
import { CountryPhoneInputComponent } from '../country-phone-input/country-phone-input.component';
import { ROUTES } from '../../../core/constants/routes.constants';

@Component({
  selector: 'app-register',
  imports: [FormsModule, RouterLink, AuthShellComponent, CountryPhoneInputComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  protected readonly routes = ROUTES;

  protected readonly fullName = signal('');
  protected readonly email = signal('');
  protected readonly password = signal('');
  protected readonly confirmPassword = signal('');
  protected readonly country = signal('India');
  protected readonly phoneNumber = signal('');
  protected readonly agreedToTerms = signal(true);
  protected readonly passwordVisible = signal(false);
  protected readonly confirmPasswordVisible = signal(false);
  protected readonly loading = signal(false);
  protected readonly errorMessage = signal('');

  protected readonly hasMinLength = computed(() => this.password().length >= 8);
  protected readonly hasNumber = computed(() => /\d/.test(this.password()));
  protected readonly hasSpecialChar = computed(() => /[^A-Za-z0-9]/.test(this.password()));

  togglePasswordVisibility(): void {
    this.passwordVisible.update((visible) => !visible);
  }

  toggleConfirmPasswordVisibility(): void {
    this.confirmPasswordVisible.update((visible) => !visible);
  }

  onSubmit(): void {
    this.errorMessage.set('');

    if (this.password() !== this.confirmPassword()) {
      this.errorMessage.set('Passwords do not match.');
      return;
    }

    if (!this.hasMinLength() || !this.hasNumber() || !this.hasSpecialChar()) {
      this.errorMessage.set('Password does not meet the requirements.');
      return;
    }

    this.loading.set(true);

    this.authService
      .register({
        fullName: this.fullName(),
        email: this.email(),
        password: this.password(),
        country: this.country(),
        phoneNumber: this.phoneNumber()
      })
      .subscribe({
        next: () => {
          this.loading.set(false);
          this.router.navigateByUrl(ROUTES.DASHBOARD);
        },
        error: () => {
          this.loading.set(false);
          this.errorMessage.set('Could not create your account. Please try again.');
        }
      });
  }
}
